import { mockData as workspaces } from '@web/lib/demo/data/workspaces';
import { DefaultResponseCodeEnum } from '@workalizer/shared';
export var updateWorkspaceSettings = function (input) {
    var workspace = workspaces.find(function (workspace) { return workspace.id === input.workspaceId; });
    if (!workspace) {
        throw new Error('Workspace not found');
    }
    return {
        success: true,
        code: DefaultResponseCodeEnum.SUCCESS
    };
};
